import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import { useBillingContext } from "./BillingContext";

const localeRoot = "settings.billing.manage_billing.plan_details";

export const PlanHeader = () => {
  const { currentPlan } = useBillingContext();

  if (!currentPlan) return null;

  return (
    <div className="flex flex-col">
      <Typography.LabelXl weight="semibold">
        {t(`${localeRoot}.plan_name.${currentPlan.tier}`)}
      </Typography.LabelXl>
      <div className="flex flex-row items-center gap-1">
        <Typography.LabelLg weight="semibold">
          {currentPlan.display_base_monthly_amount}
        </Typography.LabelLg>
        <Typography.LabelSm color="text-default" weight="medium">
          {t(`${localeRoot}.per_month`)}
        </Typography.LabelSm>
      </div>
    </div>
  );
};
